import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  AppBar,
  Box,
  Button,
  Divider,
  Toolbar,
  // Hidden,
  // Typography,
  // Link,
  makeStyles
} from '@material-ui/core';
import Logo from 'src/components/Logo';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default
  },
  toolbar: {
    height: 64
  },
  logo: {
    marginRight: theme.spacing(2),
    height: '64px'
  },
  link: {
    fontWeight: theme.typography.fontWeightMedium,
    '& + &': {
      marginLeft: theme.spacing(2)
    }
  },
  divider: {
    width: 1,
    height: 32,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('md')]:{
      display: 'none'
    }
  },
  signup:{
    [theme.breakpoints.down('md')]:{
      display: 'none'
    }
  }
}));

const TopBar = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
    <AppBar
      className={clsx(classes.root, className)}
      color="default"
      {...rest}
    >
      <Toolbar className={classes.toolbar}>
        <RouterLink to="/">
          <Logo className={classes.logo} />
        </RouterLink>
        <Box flexGrow={1} />
        <Button
          color="secondary"
          component={RouterLink}
          to="/login"
          variant="outlined"
          size="small"
        >
          Login
        </Button>
        <Divider className={classes.divider} />
        {/* <Button
          color="secondary"
          component="a"
          href="#"
          variant="outlined"
          size="small"
        >
          Get the App
        </Button> */}
        {/* <Divider className={classes.divider} /> */}
        <Button
          color="secondary"
          component={RouterLink}
          to="/signup"
          variant="contained"
          className={classes.signup}
          size="small"
        >
          Sign up your store
        </Button>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string
};

export default TopBar;
